// Top bar: week, day and the clock on the left, the Eggit pill on the right.
// Two numbers a parent checks twice a day, so nothing else lives up here.

import { icon } from '../dom';
import { div, h } from '../dom';
import { t } from '../../i18n';
import type { TopBarView } from '../selectors';

const EGGIT_ICON =
  '<circle cx="12" cy="12" r="9"></circle><path d="M12 7v10"></path><path d="M9 9.5h4.5a1.8 1.8 0 0 1 0 3.5h-3a1.8 1.8 0 0 0 0 3.5H15"></path>';

export function topBar(view: TopBarView): HTMLElement {
  return div(
    { class: 'cf-topbar' },
    div(
      { class: 'cf-stack cf-stack--tight' },
      h('span', { class: 'cf-topbar__week', text: t('coop.week', { week: view.week }) }),
      h('span', {
        class: 'cf-topbar__day',
        text: t('coop.dayClock', { day: view.day, clock: view.clock }),
      }),
    ),
    div(
      { class: 'cf-eggit' },
      icon({ shapes: EGGIT_ICON, size: 18, tone: 'warn', strokeWidth: 2.2 }),
      h('span', { class: 'cf-eggit__count cf-num', text: String(view.eggits) }),
      h('span', { class: 'cf-visually-hidden', text: t('hud.eggits') }),
    ),
  );
}
